import { useState } from 'react';

import { Calendar } from '@/components/ui/calendar';
import { Button } from '@/components/ui/catalyst/button';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover';

interface BulkDatePickerActionProps {
  selectedCount: number;
  onDateSelect: (date: Date) => void;
  disabled?: boolean;
}

/**
 * Bulk action button that shows a calendar popover for selecting a due date.
 * Used in the DataTable bulk actions bar for changing due dates of multiple tasks.
 */
export const BulkDatePickerAction = ({
  selectedCount,
  onDateSelect,
  disabled = false,
}: BulkDatePickerActionProps) => {
  const [open, setOpen] = useState(false);

  const handleDateSelect = (date: Date | undefined) => {
    if (date) {
      onDateSelect(date);
      setOpen(false);
    }
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          outline
          disabled={disabled}
          className="whitespace-nowrap !text-xs !font-medium h-8"
        >
          Change Next Action Date
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <div className="p-3 border-b border-zinc-200 dark:border-zinc-700">
          <p className="text-sm text-zinc-600 dark:text-zinc-400">
            Set next action date for {selectedCount} task
            {selectedCount !== 1 ? 's' : ''}
          </p>
        </div>
        <Calendar
          mode="single"
          selected={undefined}
          onSelect={handleDateSelect}
          className="bg-white dark:bg-zinc-900"
        />
      </PopoverContent>
    </Popover>
  );
};
